import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { COLORS } from 'constants/design';

const LabelValue = (props: { title: string; value: string }) => {
  return (
    <Grid container direction="row" alignItems="center" spacing={2}>
      <Grid item>
        <Typography
          style={{
            color: COLORS.LIGHT_GREY,
            fontWeight: 400,
            fontSize: '13px',
          }}
        >
          {props.title}
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          style={{
            color: COLORS.TEXT_BLACK,
            fontWeight: 400,
            fontSize: '13px',
          }}
        >
          {props.value}
        </Typography>
      </Grid>
    </Grid>
  );
};
export default LabelValue;
